import React from 'react';
import { Link } from 'react-router-dom';
import { formatPhilippineMobileDisplay } from '../lib/phoneNumber';

export default function AuthenticatedClientInfoFields({ name, email, phone = '', loading }) {
  const hasSavedPhone = Boolean(phone);

  return (
    <fieldset className="space-y-4 pb-6 border-b border-white/10">
      <legend className="text-base font-bold text-white">Your Information</legend>
      <p className="text-xs text-slate-400">
        Name, email{hasSavedPhone ? ', and mobile number' : ''} are taken from your signed-in account and cannot be changed here.
      </p>
      <div className="grid md:grid-cols-2 gap-4">
        <div>
          <label>Full Name</label>
          <input
            type="text"
            name="requester_name"
            value={loading ? 'Loading account...' : name}
            readOnly
            aria-readonly="true"
            className="cursor-not-allowed opacity-80"
          />
        </div>
        <div>
          <label>Email Address</label>
          <input
            type="email"
            name="requester_email"
            value={loading ? 'Loading account...' : email}
            readOnly
            aria-readonly="true"
            className="cursor-not-allowed opacity-80"
          />
        </div>
        {hasSavedPhone ? (
          <div className="md:col-span-2">
            <label>Contact Number</label>
            <input
              type="tel"
              name="requester_phone_display"
              value={loading ? 'Loading account...' : formatPhilippineMobileDisplay(phone)}
              readOnly
              aria-readonly="true"
              className="cursor-not-allowed opacity-80"
            />
            <p className="mt-1 text-xs text-slate-400">
              Change this in{' '}
              <Link to="/profile/edit" className="text-brand-gold underline underline-offset-2">
                Profile Settings
              </Link>
              .
            </p>
          </div>
        ) : null}
      </div>
    </fieldset>
  );
}
